// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"f0f81448","59":"958b1322","162":"1f14846c","314":"79b4f29b","393":"a3465ad1","466":"a13802f8","862":"2ceaf7df"}[chunkId] + ".chunk.js";
};